import {EmployeeService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        employees: [],
    },

    mutations: {
        saveEmployees(current, teachers) {
            current.employees.splice(0);
            current.employees = teachers;
        }
    },

    actions: {
        async getEmployeesWithKeyAction({commit}, key) {
            await bindLoading(commit,
                async () => commit('saveEmployees', await EmployeeService.getEmployeesWithKey(key)), 'employee');
        }
    }
}